import type { FilterDefinition } from '../engine/types';
import { FilterId, type SingleValueFilter } from '../types/filters';
import {
  defineNumericTaxonomyFilter,
  type NumericTaxonomySelection,
} from './numericTaxonomy';

export type CustomActivityTaxonomySelection = NumericTaxonomySelection;

export const activityTaxonomyDescriptor = defineNumericTaxonomyFilter({
  id: FilterId.ACTIVITY_TAXONOMY,
  name: 'Activity Taxonomy',
});

export const activityTaxonomyDefinition: FilterDefinition<
  SingleValueFilter<CustomActivityTaxonomySelection>
> = activityTaxonomyDescriptor.definition;
